__turbopack_context__.v({
  "lottie": "email-sent-lottie-module__y72dfW__lottie",
  "wrap": "email-sent-lottie-module__y72dfW__wrap",
  "wrapCompact": "email-sent-lottie-module__y72dfW__wrapCompact",
});
